import React from 'react';
import { DialogContent, Box } from '@mui/material';
import Dialog from '../../../../src/components/library/Dialog';
import DialogTitle, { CloseButton } from '../../../../src/components/library/DialogTitle';
import { Button } from '../../../../src/components/library';
import TextInput from '../../../../src/components/library/TextInput';

interface CreateFolderDialogProps {
	open: boolean;
	onClose: () => void;
	folderName: string;
	validationError: string | null;
	onFolderNameChange: (folderName: string) => void;
	onCreateFolder: () => void;
	isCreating: boolean;
}

export function CreateFolderDialog({
	open,
	onClose,
	folderName,
	validationError,
	onFolderNameChange,
	onCreateFolder,
	isCreating,
}: CreateFolderDialogProps) {
	const handleKeyPress = (event: React.KeyboardEvent) => {
		if (event.key === 'Enter' && !validationError && folderName.trim()) {
			onCreateFolder();
		}
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>
				Create New Folder
				<CloseButton onClose={onClose} />
			</DialogTitle>
			<DialogContent sx={{ m: '20px' }}>
				<Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 4 }}>
					<TextInput
						fullWidth
						ariaLabel="Folder Name"
						value={folderName}
						onChange={(e) => onFolderNameChange(e.target.value)}
						onKeyDown={handleKeyPress}
						error={validationError || undefined}
						placeholder="Enter a name for the new folder"
						disabled={isCreating}
						autoFocus
						height={34}
					/>
					<Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
						<Button
							name="Cancel"
							type="button"
							onClick={onClose}
							disabled={isCreating}
							nxstyle="secondary-black"
							sx={{ width: '100%' }}
						>
							Cancel
						</Button>
						<Button
							aria-label="Create Folder"
							sx={{ width: '100%' }}
							type="button"
							onClick={onCreateFolder}
							disabled={isCreating || !!validationError || !folderName.trim()}
							nxstyle="primary-blue"
						>
							{isCreating ? 'Creating...' : 'Create Folder'}
						</Button>
					</Box>
				</Box>
			</DialogContent>
		</Dialog>
	);
}
